// LEADZERO1: a person types ".5" meaning 0.5. Every decimal field a person types into runs its text
// through this one function before its own pattern check, so ".5" reads exactly as "0.5" and nothing
// else about the field's rules changes (a lone ".", "-.5" where negatives are refused, extra decimal
// places and commas still fail the field's own pattern).

/** Trims the text and puts a "0" in front of a leading decimal point (".5" to "0.5", ".25" to "0.25",
 * "-.5" to "-0.5"). Text without a digit right after the point (".", "") is returned trimmed and
 * otherwise untouched, so the caller's own pattern still refuses it. */
export function normalizeLeadingDot(text: string): string {
  const trimmed = text.trim();
  return trimmed.replace(/^(-?)\.(?=\d)/, (_match, sign: string) => `${sign}0.`);
}
